import { LinkGroup } from '../../link-group/link-group';
import { TreeItem, ItemType, TreeItemCheckedType } from './item';
import { DossierTree } from './tree';
import { RecordLink } from '../../record-link/record-link';
import { RecordItem } from './record-item';
import { each, filter } from 'lodash';


export class GroupItem extends TreeItem {

  public group: LinkGroup;

  constructor(group: LinkGroup, parent: TreeItem, tree: DossierTree) {
    super(parent, tree);
    this.group = group;

    each(tree.dossier.links, l => {

      if (l.isRecordLink() && l.name === group.link_name) {
        let recordLink = l as RecordLink;

        if (recordLink.group_id === group.id) {
          let item = new RecordItem(recordLink, this, tree);

          this.addChild(item);
        }
      }
    });
  }

  addChild(item: TreeItem) {
    super.addChild(item);

    this.children.sort(TreeItem.sortByLabel);
  }

  get type(): ItemType {
    return 'GROUP';
  }

  get label(): string {
    return this.group.name + ' (' + this.children.length + ')';
  }

  get isNew(): boolean {
    return !this.group.id;
  }

  get canMoveGroupUp() {
    return this.group.order < this.parent.realGroups[0].group.order;
  }

  get canMoveGroupDown() {
    return this.group.order > this.parent.realGroups[this.parent.groupsCount - 1].group.order;
  }

  get checked(): TreeItemCheckedType {
    if (this.children.length === 0) {
      return 'DISABLED';
    }
    
    let checked = filter(this.children, child => child.checked === 'YES');

    if (checked.length === this.children.length) {
      return 'YES';
    }
    else if (checked.length === 0) {
      return 'NO';
    }
    else {
      return 'INDETERMINATE';
    }
  }

  set checked(value: TreeItemCheckedType) {
    each(this.children, child => child.checked = value);
  }
}